import { useEffect, useState } from 'react';
import { consoleApi } from './admin-console';

export function SupportEntry({module,id,query={}}:{module:string;id?:string;query?:Record<string,string>}) {
  const [base,setBase]=useState('');const [error,setError]=useState('');
  useEffect(()=>{let active=true;void consoleApi<{supportAppUrl:string}>('/v1/admin/console/entrypoints').then(data=>{
    const url=new URL(data.supportAppUrl);if(!['http:','https:'].includes(url.protocol))throw new Error('客服工作台地址配置无效');
    if(url.origin===window.location.origin)throw new Error('请配置独立客服工作台的 SUPPORT_APP_URL');
    if(active)setBase(url.href);
  }).catch(e=>{if(active)setError(e instanceof Error?e.message:'客服入口读取失败');});return()=>{active=false;};},[]);
  const target=new URLSearchParams(query);if(id)target.set('id',id);
  const href=base?`${base.split('#')[0]}#${module}?${target}`:'';
  return <div className="admin-card console-support-entry"><div><b>客服管理 · 共用工单与处理记录</b><p>此处查看统计、资料和处理历史；回复、分派及流转统一在客服工作台进行。</p></div>{href?<a className="primary-admin" href={href} target="_blank" rel="noopener noreferrer">{id?'去客服工作台处理此记录':'进入客服工作台'} ↗</a>:<span role="status">{error||'正在读取客服入口…'}</span>}</div>;
}
